// Presentation helpers for the Inbox (spec 026 S3; the list and the ticket page, 047
// step 5): the status chip, the ticket's number, the badge count, a message's side.
import { STATUS_LABELS } from "./ticketContract";

// MUI Chip `color` per lifecycle state, from Figma's Tickets frame (047 D15):
// "Submitted" blue (info), "Waiting for You" amber (warning), "Resolved" green
// (success), "Closed" grey (default). The Inbox page follows.
const STATUS_COLORS = {
  open: "info",
  waiting_user: "warning",
  resolved: "success",
  closed: "default",
};

// Always the contract's own label — never a shorter dashboard-invented one,
// so the chip text can't drift from what the app and Figma call each state.
export const statusChip = (status) => ({
  label: STATUS_LABELS[status] || status,
  color: STATUS_COLORS[status] || "default",
});

// "#<number>" only when the ticket carries one (a user report — reportLesson.js
// always allocates one). A system ticket (lessonLifecycle.js, ticketBacklog.js)
// has no `number` at all, and must never render as the literal "#undefined".
export const ticketNumberLabel = (ticket) => {
  const number = ticket && ticket.number;
  if (number) return { label: `#${number}`, muted: false };
  const id = (ticket && ticket.id) || "";
  return { label: id ? id.slice(0, 8) : "—", muted: true };
};

// The Layout nav badge counts *only* open ("Submitted") tickets — waiting_user
// is still unresolved but is not the "jump on this" queue the badge is for.
export const inboxBadgeCount = (counts) => (counts && counts.openTickets) || 0;

// A thread has exactly two sides: the party who raised it (`raisedBy`) and
// staff — firestore.rules' messages-create rule allows no one else to write.
// A system ticket has raisedBy: null, so every message on it reads as staff's.
export const isStaffMessage = (ticket, message) =>
  (message && message.senderId) !== (ticket && ticket.raisedBy);
